<template>
  <div class="box1">
    <h2 class="title">{{ dealer.name }}轮胎保障尊享服务条款</h2>
    <h4>一、相关定义</h4>
    <p class="fix-indent">
      <strong>车辆：</strong>是指在《{{ dealer.name }}轮胎保障尊享服务条款》（以下称“本条款”）中载明的梅赛德斯-奔驰乘用车或精灵 (“
      smart”)，不包括该车辆标准配置以外的新增设备。
    </p>
    <p class="fix-indent">
      <strong>车辆轮胎鼓包：</strong
      >是指轮胎在车辆行驶过程中因为撞击坑洞、凸沿及其它障碍物，轮胎在轮毂凸缘和冲击物之间产生严重的挤压变形，胎体帘子线因过度拉伸而断裂，轮胎内部空气则从断线处顶起形成鼓包。
    </p>
    <p class="fix-indent"><strong>客户：</strong>是指在本条款中确认并同意接受轮胎保障尊享服务的自然人或法人。</p>
    <p class="fix-indent"><strong>经销商：</strong>是{{ dealer.name }}。</p>
    <h4>二、保障期间</h4>
    <p>保障期间为本条款签署之日起一年或行驶里程两万公里以内（以先到为准）。</p>
    <h4>三、保障内容和范围</h4>
    <p>除保修范围以外，在保障期间内客户车辆轮胎发生鼓包，可支付厂商建议零售价的30%购买同型号新轮胎。</p>
    <p>
      本服务仅保障车辆轮胎（出厂4条，不含备胎），保障期间内车辆总计最多更换2条轮胎（可分两次更换）。本服务不含备胎的检验与更换，不含如轮胎动平衡、轮胎压力监测、定位检查、调整刹车制动系统等检测。
    </p>
    <h4>四、保障适用条件</h4>
    <p>
      车辆销售之日当日签署轮胎保障尊享服务协议的客户车辆。本条款仅适用于{{
        dealer.name
      }}销售的车辆，不适用于非经销商销售的车辆，并仅限使用性质为非营运、非公共服务用途车辆、非比赛竞赛用车的车辆。
    </p>
    <h4>五、不属于保障范围的情形</h4>
    <p class="fix-indent">出现下列任一情形时，经销商不提供轮胎保障尊享服务：</p>
    <div class="fix-indent">
      <span>1. 车辆被用于以下用途:</span>
      <ul>
        <li>
          比赛、竞赛和越野用车(如果车辆是特别为上述目的而设计的除外)，用于短期自驾租赁的车辆，出租车和驾驶学校用车，快递车辆以及任何用于其他租赁或者取得报酬的车辆；
        </li>
        <li>公共服务车辆(如：警用、消防、救护、救助和军事目的)，但不包括政府机关、企事业单位等一般性公务用车。</li>
      </ul>
    </div>
    <p class="fix-indent">2. 客户在非授权经销商处更换过出厂轮胎，或使用与本条款记录轮胎型号不符的轮胎；</p>
    <p class="fix-indent">3. 客户的车辆在原厂质保期内曾在非授权经销商处进行了修理或保养，并基于上述修理或保养形成轮胎鼓包；</p>
    <p class="fix-indent">4. 里程表遭更换、修改或未连接，致使无法确定车辆的实际行驶里程数；</p>
    <p class="fix-indent">5. 未遵守车辆操作、维护和保养相关要求(如车主手册)或未遵守季节和区域规范操作，如在冬季使用夏季轮胎；</p>
    <p class="fix-indent">6. 客户没有及时报告/记录故障(或损坏)或没有提供及时维修的机会，或客户拒绝及时对配件进行检查、诊断及技术上必要的修复；</p>
    <p class="fix-indent">7. 在中国大陆以外地区使用的车辆的任何损失；</p>
    <p class="fix-indent">8. 由于客户或车主的欺诈、不诚实或故意、恶意、违法、犯罪行为所产生的责任；</p>
    <p class="fix-indent">9. 任何由战争、军事冲突、恐怖活动、核辐射、核爆炸及其他核能风险、地震及其次生灾害所致的直接或间接损失；</p>
    <p class="fix-indent">
      10.
      自然灾害、意外事故、盗抢、腐蚀、第三方人为原因以及其他外来的事故或原因，例如冰雹、碎石、鸟粪、路盐、工业烟雾/粉尘、花粉、金属粉末、洪水、暴风、雷电、放射性尘埃、树胶、地震、海水、酸雨、故意破坏、非法闯入、使用含铅、含甲醇或不合格的汽油等；
    </p>
    <p class="fix-indent">11. 应政府监管机构要求而检测或更换零配件的费用。</p>
    <h4>六、咨询与联络</h4>
    <p class="fix-indent">客户可通过“Mercedes Me我的奔驰”微信公众服务号查询全国各经销商联系方式进行咨询、投诉或建议。</p>
    <h4>七、变更车主</h4>
    <p>
      如果车辆变更车主，原车主、新车主及经销商三方需共同确认基于本条款项下的权利义务的转移，否则，本条款将视为在变更时自动终止，将不适用于所有权变更后的车辆。
      即原车主向经销商提出变更申请，新车主与经销商需重新签署本条款。变更前后车辆的保障期间不受车辆所有权变更的影响。
    </p>
    <h4>八、信息及条款确认</h4>
    <div class="card">
      <van-cell title="车辆信息登记"></van-cell>
      <van-cell title="车主姓名" :value="vehicle.name"></van-cell>
      <van-cell title="手机号" :value="dealer.tel"></van-cell>
      <van-cell title="车架号" :value="vehicle.encoded_vin"></van-cell>
      <van-cell title="当前里程" :value="`${vehicle.mileage || 0} km`"></van-cell>
      <van-cell title="车牌号（可空）" :value="vehicle.plate"></van-cell>
      <van-cell title="签署日期" :value="addEightHour(vehicle.insurance.created_at, 'day')"></van-cell>
    </div>
    <div v-for="tyre in vehicle.tyres" :key="tyre.id" class="card">
      <van-cell :title="tyre.tyre_group_label + '轮胎信息'"></van-cell>
      <van-cell title="位置" :value="tyre.tyre_group_label"></van-cell>
      <van-cell title="品牌" :value="tyre.brand_cn"></van-cell>
      <van-cell title="型号" :value="tyre.spec"></van-cell>
      <van-cell title="花纹" :value="tyre.pattern"></van-cell>
      <van-cell title="DOT（出厂年份及月份）" :value="tyre.dot"></van-cell>
    </div>
    <br />
    <p>
      烦请仔细阅读并充分理解《{{ dealer.name }}轮胎保障尊享服务条款》的全部内容及轮胎登记信息内容，同时确认同意按本条款享受{{
        dealer.name
      }}轮胎保障尊享服务条款。
    </p>
    <!-- <p v-if="!claimed">客户在下方点击“同意”即视为接受本条款的全部内容。</p> -->
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { addEightHour } from '@/util/index'
export default {
  name: 'Clause',
  props: ['dealer', 'vehicle'],
  setup(props) {
    let { dealer, vehicle } = toRefs(props)
    const state = reactive({
      dealer,
      vehicle,
      count: 0
    })

    return {
      ...toRefs(state),
      addEightHour
    }
  }
}
</script>

<style lang="scss" scoped>
.box1 {
  text-align: left;
  color: #999;
}
h4 {
  margin: 8px 0;
  color: #666666;
  font-weight: bold;
}

.fix-indent {
  margin: 4px 0;
}
.van-cell {
  // padding: 0.26667rem 0;
  justify-content: space-between;
  font-size: 14px;
  :deep(.van-cell__title) {
    color: #999;
    font-size: 14px;
    // flex-grow: 2;
    flex: auto;
  }
  :deep(.van-cell__value) {
    font-size: 14px;
    flex: auto;
  }
}
.card {
  margin-top: 12px;
  box-shadow: 0 0 2px #cccccc;
}
.title {
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: #666;
}
</style>
